import { createFileRoute } from "@tanstack/react-router";
import AdminExperts from "@/pages/admin/AdminExperts";

export const Route = createFileRoute("/admin/profesionales")({ component: AdminExperts });
